import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			heHubPulsarsDiscoveryValuesContentSectionHeaderCls: string;
			heHubPulsarsDiscoveryValuesBoxEnumItemCls: string;
		}
	},

	slug: string
}

class Values extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('He Hub Pulsars Discovery Values Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubPulsarsDiscoveryValuesContentSectionHeaderCls || '', 'he_hub_pulsars_discovery_values', { animCls: 'animate__fadeInLeft25P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubPulsarsDiscoveryValuesBoxEnumItemCls + '1', 'he_hub_pulsars_discovery_values', { animCls: 'animate__zoomIn50P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubPulsarsDiscoveryValuesBoxEnumItemCls + '2', 'he_hub_pulsars_discovery_values', { animCls: 'animate__zoomIn50P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubPulsarsDiscoveryValuesBoxEnumItemCls + '3', 'he_hub_pulsars_discovery_values', { animCls: 'animate__zoomIn50P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubPulsarsDiscoveryValuesBoxEnumItemCls + '4', 'he_hub_pulsars_discovery_values', { animCls: 'animate__zoomIn50P', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Values;